import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;
const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	// top: 0;
  z-index: 10;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    // top: 30%;
		// right: 0px;
    visibility: visible;
    animation: ${appearFromRight} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromRight} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
	align-items: center;
  background: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 10px;
  width: 40%;
	height: auto;
	max-width: 90%;
	max-height: 90%;
  visibility: hidden;
  transition: all 0.5s ease-out;

	scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;

  h1 {
    font-size: 18px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #455a64;
  }

	// 850px
	@media (max-width: 53.125rem) {
    right: 0px;
    // top: 800px;
    width: 90%;
    margin-top: 0px;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;

		button {
			font-size: 13px;
			padding: 5px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const ContentData = styled.div`
	display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	padding: 10px 20px 0;
	margin-bottom: -1px;
  overflow-y: auto;
	scroll-behavior: smooth;

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 10px 10px;
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center; // space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;

	padding: 5px 0;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 2px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;